// extracted by mini-css-extract-plugin
export default {"notFoundBanner":"NotFound_notFoundBanner__e2UVw"};